import React from 'react'
import PropTypes from 'prop-types'
import EmptyNotificationImage from '../../../../assets/images/no-notifications.jpg'

export function Empty({ smallVersion }) {
  const description = smallVersion
    ? 'Semua pemberitahuan yang kami kirim akan muncul di sini, sehingga Anda dapat melihatnya dengan mudah kapan saja'
    : 'Saat ini kamu belum memiliki pemberitahuan di kategori ini'

  const style = {
    description: smallVersion ? 'small-title-1' : 'title-3'
  }

  return (
    <div className='notification-empty'>
      <img className="notification-empty__image" src={EmptyNotificationImage} />
      <h3 className="notification-empty__title title-2">Belum Ada Notifikasi</h3>
      <p className={`notification-empty__desc ${style.description}`}>{description}</p>
    </div>
  )
}

Empty.propTypes = {
  smallVersion: PropTypes.bool.isRequired
}
